import { reactive } from '@wix/bex-utils';
import { RefObject } from './RefObject';
import { makeObservable, observable } from 'mobx';

export interface PageStateParams {}

export class PageState {
  readonly modalsContainerRef: RefObject<HTMLElement>;

  readonly stackingRootRef: RefObject<HTMLElement>;

  readonly scrollableContentRef: RefObject<HTMLElement>;

  _sidePanelReservedWidth = reactive<number>(0);

  private readonly sidePanelWidths = new Map<object, number>();

  constructor() {
    this.modalsContainerRef = makeObservable(
      { current: null },
      { current: observable.ref },
    );
    this.stackingRootRef = { current: null };
    this.scrollableContentRef = { current: null };
  }

  /**
   * Keyed by host so a page with two side panels keeps the widest open one
   * instead of the last that reported. A width of 0 removes the host's entry.
   */
  setSidePanelReservedWidth(host: object, width: number) {
    if (width > 0) {
      this.sidePanelWidths.set(host, width);
    } else {
      this.sidePanelWidths.delete(host);
    }

    this._sidePanelReservedWidth.value = Math.max(
      0,
      ...this.sidePanelWidths.values(),
    );
  }
}
